module.exports = __webpack_public_path__ + "img/sheji.95b09e86.png";